import api from './api';

const trustedDevicesService = {
  getDevices: async (params = {}) => {
    const response = await api.get('/devices', { params });
    return response.data;
  },

  getPendingCount: async () => {
    const response = await api.get('/devices/pending-count');
    return response.data.data;
  },

  approveDevice: async (deviceId, expiresAt = null) => {
    const response = await api.put(`/devices/${deviceId}/approve`, { expires_at: expiresAt });
    return response.data;
  },

  blockDevice: async (deviceId) => {
    const response = await api.put(`/devices/${deviceId}/block`);
    return response.data;
  },

  deleteDevice: async (deviceId) => {
    const response = await api.delete(`/devices/${deviceId}`);
    return response.data;
  },

  updateDeviceName: async (deviceId, deviceName) => {
    const response = await api.put(`/devices/${deviceId}/name`, { device_name: deviceName });
    return response.data;
  },

  getLoginAttempts: async (params = {}) => {
    const response = await api.get('/devices/login-attempts', { params });
    return response.data;
  }
};

export default trustedDevicesService;
